module.exports = __webpack_public_path__ + "20240105162613/img/logo.0e1a9873.png";